import { useMutation, useQuery } from '@tanstack/react-query';
import { labelQueries, labelMutations } from './labels.queries';

export function useLabels(options?: { suspense?: boolean }) {
  return useQuery({ ...labelQueries.list(), ...options });
}

export function useLabel(id: number, options?: { suspense?: boolean }) {
  return useQuery({ ...labelQueries.detail(id), ...options });
}

export function useCreateLabel() {
  return useMutation(labelMutations.create());
}

export function useUpdateLabel() {
  return useMutation(labelMutations.update());
}

export function useDeleteLabel() {
  return useMutation(labelMutations.delete());
}
